import type { Opaque } from '@disy/lib/opaque';
import type { Data } from '@disy/ui.responsive-table/responsive-table';

import { ajax } from 'cadenza/api-client/api';
import type { Problem } from 'cadenza/api-client/dto/problem-dto';
import type { WorldBoxDto } from 'cadenza/api-client/dto/world-box-dto';
import type { ReferenceSystemId } from 'cadenza/api-client/model/reference-system-id.gen';

export type Authority = Opaque<'Authority', string>;

export function searchSrses(
  frontendSupportedOnly: boolean,
  { term, offset = 0, limit = 10 }: { term?: string; offset?: number; limit?: number } = {},
) {
  return ajax<Data<SrsDto>>('/srses?', {
    type: 'GET',
    data: { 'filter.text': term, offset, limit, frontendSupportedOnly },
  });
}

export function getSrs(authority: Authority) {
  return ajax<SrsDto>(`/srses/${authority}`);
}

export function getSrsMaxExtent(authority: Authority) {
  return ajax<WorldBoxDto>(`/srses/${authority}/max-extent`);
}

export async function hasMaxExtent(authority: Authority) {
  try {
    await ajax<WorldBoxDto>(`/srses/${authority}/max-extent`, { type: 'HEAD' });
    return true;
  } catch (error) {
    if ((error as Problem).key !== 'max-extent-not-configured') {
      throw new Error(`Failed to get max extent for srs [${authority}].`, { cause: error });
    }
    return false;
  }
}

/** See net.disy.cadenza.workbook.map.web.dto.SrsDto */
export interface SrsDto {
  authority: Authority;
  coordinateDisplay: boolean;
  description?: string;
  printName: string;
  /** On SRS provided by geotools we don't have an id. This is only present for SRS saved on the MC. */
  referenceSystemId?: ReferenceSystemId;
  referenceSystemOrder?: number;
  selectionDialogs: boolean;
}
